// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__11f5M","icon":"SortAdornment_icon__2unW-","up":"SortAdornment_up__1dR-I","down":"SortAdornment_down__2R0dy","active":"SortAdornment_active__4Y78M"};